module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目名称"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.filters.projectId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "projectId", $$v)
      },
      expression: "filters.projectId"
    }
  }, _vm._l((_vm.projects), function(item) {
    return _c('el-option', {
      key: item.projectId,
      attrs: {
        "label": item.name,
        "value": item.projectId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "year"
    },
    model: {
      value: (_vm.filters.date),
      callback: function($$v) {
        _vm.$set(_vm.filters, "date", $$v)
      },
      expression: "filters.date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('create-form-button', {
    on: {
      "select-type": _vm.bornForm
    }
  }), _vm._v(" "), _c('download-form-button', {
    on: {
      "select-type": _vm.clickBtn
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "formCon",
      "element-loading-text": "报表生成中",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.8)"
    }
  }, [_c('div', {
    attrs: {
      "id": "title"
    }
  }, [_c('div', {
    staticClass: "title1"
  }, [_c('span', [_vm._v(_vm._s(_vm.projectName) + "环境噪声状况分析报告")])]), _vm._v(" "), _c('div', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "span2"
  }, [_vm._v(" " + _vm._s(_vm.date2))])]), _vm._v(" "), _c('div', {
    staticClass: "title3"
  }, [_c('span', [_vm._v(_vm._s(_vm.date2) + "噪声年报")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "con1"
    }
  }, [_c('div', {
    staticClass: "contitle"
  }, [_vm._v("一、运行情况")]), _vm._v(" "), _c('div', {
    staticClass: "contitle"
  }, [_vm._v("1.设备运行情况")]), _vm._v(" "), (_vm.totalData.statusStr == '') ? _c('p', {
    staticClass: "condes"
  }, [_vm._v(_vm._s(_vm.date1) + "各站点监测设备整体运行正常。")]) : _c('p', {
    staticClass: "condes"
  }, [_vm._v(_vm._s(_vm.date1) + "各站点监测设备运行情况：" + _vm._s(_vm.totalData.statusStr) + "。其他监测设备运行正常。")]), _vm._v(" "), _c('div', {
    staticClass: "contitle"
  }, [_vm._v("2.软件运行情况")]), _vm._v(" "), _c('p', {
    staticClass: "condes"
  }, [_vm._v(_vm._s(_vm.date1) + "各平台运行状况良好，未进行功能调整或修复。")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "con2"
    }
  }, [_c('div', {
    staticClass: "contitle"
  }, [_vm._v("二、全区噪声情况")]), _vm._v(" "), _c('div', {
    staticClass: "contitle"
  }, [_vm._v("1.噪声概况")]), _vm._v(" "), _c('p', {
    staticClass: "condes"
  }, [_c('span', [_vm._v("计算各点位" + _vm._s(_vm.date1) + "的数据均值，")]), _c('span', [_vm._v(_vm._s(_vm.totalData.allStr) + "。")]), (_vm.totalData.rateStr != '') ? _c('span', [_vm._v("环比去年，" + _vm._s(_vm.totalData.rateStr) + "。")]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "con2add"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "con3"
    }
  }, [_c('div', {
    staticClass: "contitle"
  }, [_vm._v("2.噪声变化趋势（日均值折线图）")]), _vm._v(" "), _c('div', {
    staticClass: "chartDiv1",
    attrs: {
      "id": "chart1"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart1img"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto",
      "text-align": "center"
    },
    attrs: {
      "id": "calimg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "con4"
    }
  }, [_c('div', {
    staticClass: "contitle"
  }, [_vm._v("3.各点位值和环比情况")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "con4add"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "con5"
    }
  }, [_c('div', {
    staticClass: "contitle"
  }, [_vm._v("4.各点位均值值排名情况")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "con5add"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "con6"
    }
  }, [_c('div', {
    staticClass: "contitle"
  }, [_vm._v("5.各功能区达标率统计情况")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "con6add"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chartDiv1",
    attrs: {
      "id": "chart6"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart6img"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-7ba61cb7"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/form/year.vue
// module id = 1949
// module chunks = 1